import apollo from '@/graphql'
import WholesalersQuery from '@/graphql/wholesaler/WholesalersQuery.gql'

// initial state
const state = {
  wholesalers: [],
}

// getters
const getters = {
  wholesalers: st => st.wholesalers,
}

// mutations
const mutations = {
  setWholesalers(st, wholesalers) {
    state.wholesalers = wholesalers
  },
}

// actions
const actions = {
  loadWholesalers({ commit }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: WholesalersQuery,
    }).subscribe(({ data: { wholesalers } }) => {
      commit('setWholesalers', wholesalers)
    })
  },
}


export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/wholesaler/WholesalerList.js